import React, { useEffect, useState } from "react";
import parse from "html-react-parser";

const UpdateScripts = ({ bodyScript, headScript, setLoading }) => {
  const [scriptListsBody, setScriptListsBody] = useState([]);
  const [scriptListHead, setScriptListHead] = useState([]);

  useEffect(() => {
    if (bodyScript) {
      //bodyDiv.innerHTML = str;
      let tempscripts = bodyScript;
      if (tempscripts.includes("</script>")) {
        let checkScripts = tempscripts.split("</script>");
        if (checkScripts) {
          checkScripts.forEach((element) => {
            if (element) {
              let tempScript = element + "</script>";
              convertScripts(tempScript, "body");
            }
          });
        }
      } else {
        let bodyDiv = document.getElementById("body-script");
        if (bodyDiv) {
          bodyDiv.innerHTML = tempscripts;
        }
      }
    }
  }, [bodyScript]);

  useEffect(() => {
    if (headScript) {
      let tempscripts = headScript;
      if (tempscripts.includes("</script>")) {
        let checkScripts = tempscripts.split("</script>");
        if (checkScripts) {
          checkScripts.forEach((element) => {
            if (element) {
              let tempScript = element + "</script>";
              convertScripts(tempScript, "head");
            }
          });
        }
      }else if (headScript.includes("<meta")) {
        //create meta tag
        let meta = document.createElement("meta");
        let metaName = headScript.split("name=")[1];
        metaName = metaName.split('"')[1];
        meta.setAttribute("name", metaName);
        let content = headScript.split("content=")[1];
        content = content.split('"')[1];
        meta.setAttribute("content", content);
        document.getElementsByTagName("head")[0].appendChild(meta);
      }
    }
  }, [headScript]);

  const convertScripts = (stringScript, typeScript) => {
    let scriptContent = null;
    let scriptBody = null;
    if (stringScript.includes("<script ")) {
      scriptContent = stringScript.split("<script ")[1].split("</script>")[0];
      if (scriptContent.includes(">")) {
        scriptContent = scriptContent.split(">")[0];
      }
    } else {
      scriptContent = stringScript.split("<script>")[1].split("</script>")[0];
      scriptBody = stringScript.split("<script>")[1].split("</script>")[0];
    }

    let isAsync = stringScript.includes("async") ? true : false;
    let scriptSrc = null;
    let scriptType = null;
    if (scriptContent.includes("src=")) {
      scriptSrc = scriptContent.split("src=")[1].split(" ")[0];
    }
    if (scriptContent.includes("type=")) {
      scriptType = scriptContent.split("type=")[1].split(" ")[0];
    }

    if (scriptSrc) {
      if (scriptSrc.startsWith('"')) {
        scriptSrc = scriptSrc.substring(1);
      }

      if (scriptSrc.endsWith('"')) {
        scriptSrc = scriptSrc.substring(0, scriptSrc.length - 1);
      }
    }

    if (scriptType) {
      if (scriptType.startsWith('"')) {
        scriptType = scriptType.substring(1);
      }

      if (scriptType.endsWith('"')) {
        scriptType = scriptType.substring(0, scriptType.length - 1);
      }
    }

    const scriptObject = {
      isAsync: isAsync,
      scriptSrc: scriptSrc,
      scriptType: scriptType,
      scriptBody: scriptBody,
    };
    if (typeScript === "body") {
      setScriptListsBody((prev) => [...prev, scriptObject]);
    } else {
      setScriptListHead((prev) => [...prev, scriptObject]);
    }
  };

  useEffect(() => {
    if (scriptListsBody.length > 0) {
      scriptListsBody.forEach((element) => {
        setLoading(true);
        const script = document.createElement("script");
        if (element.scriptType) {
          script.type = element.scriptType.trim();
        }

        if (element.scriptSrc) {
          script.src = element.scriptSrc.trim();
        }
        script.async = true;

        if (element.scriptBody) {
          script.onload = element.scriptBody;
        } else {
          script.addEventListener("load", (event) => {
            console.log("script is loaded");
          });
        }

        let divBody = document.getElementById("body-script");
        if (divBody) {
          divBody.appendChild(script);
          setLoading(false);
          return () => {
            divBody.removeChild(script);
          };
        } else {
          setLoading(false);
        }
      });
    }
  }, [scriptListsBody]);

  useEffect(() => {
    if (scriptListHead.length > 0) {
      scriptListHead.forEach((element) => {
        setLoading(true);
        const script = document.createElement("script");
        if (element.scriptType) {
          script.type = element.scriptType.trim();
        }

        if (element.scriptSrc) {
          script.src = element.scriptSrc.trim();
        }
        script.async = element.isAsync;

        if (element.scriptBody) {
          script.text = parse(element.scriptBody);
          script.onload = parse(element.scriptBody);
        }

        document.head.appendChild(script);
        setLoading(false);
        return () => {
          document.head.removeChild(script);
        };
      });
    }
  }, [scriptListHead]);
  return <></>;
};

export default UpdateScripts;
